import React, { useContext } from "react";
import TooltipWrapper from "./TooltipWrapper";
import { useCaptureEvent } from "../../hooks/useCaptureEvent";
import { Skeleton } from "../ui/skeleton";
import Image from "../Tags/Image";

export default function ProfileInfo({ infoData, social }) {
  console.log("infoData", infoData);
  const captureEvent = useCaptureEvent();
  return (
    <>
      {infoData?.first_name || infoData?.full_name ? (
        <div className="">
          <div className="">
            <div
              className={`flex items-start space-x-2 ${infoData?.headline ? "items-start" : "items-center"}`}
            >
              <Image
                src="/images/ext/theme/avatar2.svg"
                alt="User"
                width={32}
                height={32}
                className={`mr-2 no-invert ${infoData?.headline ? "mt-1" : ""}`}
              />
              <span className="inline-flex flex-col">
                <span className="text-[18px] text-gray-900 block font-semibold">
                  {infoData?.full_name
                    ? infoData?.full_name
                    : `${infoData?.first_name} ${infoData?.last_name ? infoData?.last_name : ""}`}
                </span>
                {infoData?.headline && (
                  <span className="text-[13px] text-gray-600 block mt-[1px]">{infoData?.headline}</span>
                )}
              </span>
              {/* {infoData?.company_name && (
                <span>
                  <img
                    src="images/ext/company-placeholder.svg"
                    alt="Company"
                    className="opacity-70 no-invert"
                  />
                </span>
              )} */}
            </div>
            {infoData?.company_name && (
              <div className="flex items-center space-x-2 mt-2">
                <Image
                  src="/images/ext/theme/building.svg"
                  alt="Company"
                  width={24}
                  height={24}
                  className="mr-4 no-invert"
                />
                {infoData?.company_name && (
                  <span className="text-[14px] text-gray-600 mt-0.5">{infoData?.company_name}</span>
                )}
              </div>
            )}
            {social && social.length > 0 && (
              <div className="mt-4 leading-none">
                {social.map((item) => (
                  <div className="inline-flex items-center">
                    <a
                      href={item.value}
                      target="_blank"
                      className="inline-flex items-center mr-4 next__button__leading__none"
                      onClick={() => {
                        captureEvent("EXP_Person_SocialMediaBtn", {
                          link_type: item?.type,
                        });
                      }}
                    >
                      <TooltipWrapper content={item?.type} cursor="cursor-pointer">
                        <span className="inline-flex text-center">
                          <Image
                            src={`/images/ext/social/${item.type}.svg`}
                            alt={item.type}
                            width={20}
                            className="opacity-70 no-invert"
                          />
                        </span>
                      </TooltipWrapper>
                    </a>
                  </div>
                ))}
              </div>
            )}
            {/* <div
              className={`${infoData?.company_name ? "mt-4 space-y-2" : ""} `}
            >
              {infoData?.company_name && (
                <div className="flex items-center">
                  <span className="inline-flex text-center mr-2">
                    <img
                      src="images/ext/company-placeholder.svg"
                      alt="Company"
                      className="opacity-70 no-invert"
                    />
                  </span>
                  <span className="text-[14px] text-gray-600">
                    {infoData?.company_name}
                  </span>
                </div>
              )}
              {infoData?.location && (
                <div className="flex items-center">
                  <span className="inline-flex w-10 text-center">
                    <Image className="no-invert" src="/images/ext/theme/location.svg" alt="Location" />
                  </span>
                  <span className="text-[12px] text-gray-900">
                    {infoData?.location}
                  </span>
                </div>
              )}
            </div> */}
          </div>
        </div>
      ) : (
        <Skeleton className="h-[125px] w-full rounded-xl" />
      )}
    </>
  );
}
